import React, { FC } from 'react';
import styled from 'styled-components';

export interface ImageProps {
    src: string;
    style?: React.CSSProperties;
    alt: string;
    disabled?: boolean;
    onClick?: (args?: any) => void;
}

const Img = styled.img<ImageProps>`
    outline: none;

    ${(props) =>
        props.onClick &&
        `
        cursor: pointer;
    `}

    ${(props) =>
        props.disabled &&
        `
        cursor: default;
    `}
`;

const Image: FC<ImageProps> = (props) => {
    return (
        <Img
            {...props}
            disabled={props.disabled}
            onClick={() => !props.disabled && props.onClick?.()}
        />
    );
};

export { Image };
